export const IgAccountEnum = {
    prefix: 'ig_account',
    fields: {
        biography: 'biography',
        followers: 'followers',
        follows: 'follows',
        igAccount: 'ig_account',
        image: 'image',
        mediaCount: 'media_count',
        website: 'website',
    },
} as const;

export const IgAccTimeEnum = {
    prefix: 'ig_account_time',
    fields: {
        accountsEngaged: 'accounts_engaged',
        comments: 'comments',
        commentsAd: 'comments_ad',
        commentsPost: 'comments_post',
        commentsReel: 'comments_reel',
        commentsStory: 'comments_story',
        date: 'date',
        followers: 'followers',
        followersUnknown: 'followers_unknown',
        follows: 'follows',
        igAccount: 'ig_account',
        impressions: 'impressions',
        likes: 'likes',
        likesAd: 'likes_ad',
        likesPost: 'likes_post',
        likesReel: 'likes_reel',
        likesStory: 'likes_story',
        month: 'month',
        profileActivity: 'profile_activity',
        profileActivityBookNow: 'profile_activity_book_now',
        profileActivityCall: 'profile_activity_call',
        profileActivityDirection: 'profile_activity_direction',
        profileActivityEmail: 'profile_activity_email',
        profileActivityInstantExperience: 'profile_activity_instant_experience',
        profileActivityOther: 'profile_activity_other',
        profileActivityText: 'profile_activity_text',
        profileViews: 'profile_views',
        reach: 'reach',
        reachAd: 'reach_ad',
        reachAdFollower: 'reach_ad_follower',
        reachAdNonFollower: 'reach_ad_non_follower',
        reachAdUnknown: 'reach_ad_unknown',
        reachFollower: 'reach_follower',
        reachFollowerPercentage: 'reach_follower_percentage',
        reachNonFollower: 'reach_non_follower',
        reachNonFollowerPercentage: 'reach_non_follower_percentage',
        reachPost: 'reach_post',
        reachPostFollower: 'reach_post_followers',
        reachPostNonFollower: 'reach_post_non_follower',
        reachPostUnknown: 'reach_post_unknown',
        reachReel: 'reach_reel',
        reachReelFollower: 'reach_reel_follower',
        reachReelNonFollower: 'reach_reel_non_follower',
        reachReelUnknown: 'reach_reel_unknown',
        reachStory: 'reach_story',
        reachStoryFollower: 'reach_story_follower',
        reachStoryNonFollower: 'reach_story_non_follower',
        reachStoryUnknown: 'reach_story_unknown',
        reachUnknown: 'reach_unknown',
        reachUnknownPercentage: 'reach_unknown_percentage',
        saves: 'saves',
        savesAd: 'saves_ad',
        savesPost: 'saves_post',
        savesReel: 'saves_reel',
        savesStory: 'saves_story',
        shares: 'shares',
        sharesAd: 'shares_ad',
        sharesPost: 'shares_post',
        sharesReel: 'shares_reel',
        sharesStory: 'shares_story',
        textMessageClicks: 'text_message_clicks',
        totalInteractions: 'total_interactions',
        totalInteractionsAd: 'total_interactions_ad',
        totalInteractionsPost: 'total_interactions_post',
        totalInteractionsReel: 'total_interactions_reel',
        totalInteractionsStory: 'total_interactions_story',
        unfollowers: 'unfollowers',
        websiteClicks: 'website_clicks',
        week: 'week',
        weekday: 'weekday',
    },
} as const;

export const IgMediaEnum = {
    prefix: 'social_media',
    fields: {
        avgWatchTime: 'avg_watch_time',
        caption: 'caption',
        captionSentiment: 'caption_sentiment',
        captionsNegativity: 'captions_negativity',
        captionsPositivity: 'captions_positivity',
        comments: 'comments',
        commentsNegativity: 'comments_negativity',
        commentsPositivity: 'comments_positivity',
        contentType: 'content_type',
        date: 'date',
        engagementRate: 'engagement_rate',
        followers: 'followers',
        hour: 'hour',
        igAccount: 'ig_account',
        resources: 'resources',
        impressions: 'impressions',
        interactions: 'total_interactions',
        likes: 'likes',
        mediaCount: 'media_count',
        mediaId: 'media_id',
        mediaType: 'media_type',
        month: 'month',
        navigation: 'navigation',
        navigationSwipeBack: 'navigation_swipe_forward',
        navigationTapBack: 'navigation_tap_back',
        navigationTapExit: 'navigation_tap_exit',
        navigationTapForward: 'navigation_tap_forward',
        negativeCaptions: 'negative_captions',
        negativeComments: 'negative_comments',
        permalink: 'permalink',
        plays: 'plays',
        positiveCaptions: 'positive_captions',
        positiveComments: 'positive_comments',
        profileActivity: 'profile_activity',
        profileActivityBio: 'profile_activity_bio_link_clicked',
        profileActivityCall: 'profile_activity_call',
        profileActivityDirection: 'profile_activity_direction',
        profileActivityEmail: 'profile_activity_email',
        profileActivityOther: 'profile_activity_other',
        profileActivityText: 'profile_activity_text',
        profileViews: 'profile_views',
        publishDate: 'publish_date',
        reach: 'reach',
        saves: 'saved',
        shares: 'shares',
        username: 'username',
        viewTotalTime: 'view_total_time',
        week: 'week',
        weekday: 'weekday',
    },
} as const;

export const IgMediaTimeEnum = {
    prefix: 'social_media_time',
    fields: {
        comments: 'comments',
        commentsNegativity: 'comments_negativity',
        commentsPositivity: 'comments_positivity',
        date: 'date',
        igAccount: 'ig_account',
        impressions: 'impressions',
        likes: 'likes',
        mediaId: 'media_id',
        month: 'month',
        negativeComments: 'negative_comments',
        positiveComments: 'positive_comments',
        reach: 'reach',
        saves: 'saved',
        week: 'week',
        weekday: 'weekday',
        followers: 'followers',
        profileActivity: 'profile_activity',
        profileViews: 'profile_views',
        shares: 'shares',
        interactions: 'total_interactions',
    },
} as const;

export const IgCommentEnum = {
    prefix: 'social_comment',
    fields: {
        commentId: 'comment_id',
        commentsCount: 'comments_count',
        commentsNegativity: 'comments_negativity',
        commentsPositivity: 'comments_positivity',
        date: 'date',
        hour: 'hour',
        igAccount: 'ig_account',
        likes: 'likes',
        mediaId: 'media_id',
        month: 'month',
        negativeComments: 'negative_comments',
        parentCommentId: 'parent_comment_id',
        positiveComments: 'positive_comments',
        publishDate: 'publish_date',
        replies: 'replies',
        sentiment: 'sentiment',
        text: 'text',
        username: 'username',
        week: 'week',
        weekday: 'weekday',
    },
} as const;

export const IgUserEnum = {
    prefix: 'contact',
    fields: {
        biography: 'ig_biography',
        captionsNegativity: 'captions_negativity',
        captionsPositivity: 'captions_positivity',
        commentsCount: 'comments_count',
        commentsNegativity: 'comments_negativity',
        commentsPositivity: 'comments_positivity',
        followers: 'ig_followers',
        follows: 'ig_follows',
        igAccount: 'ig_account',
        image: 'ig_image',
        influencer: 'ig_influencer',
        interactions: 'interactions',
        interactionsNegativity: 'interactions_negativity',
        interactionsPositivity: 'interactions_positivity',
        lastInteractionAt: 'last_interaction_at',
        level: 'ig_level',
        mediaCount: 'ig_media_count',
        tagsCount: 'tags_count',
        name: 'ig_name',
        negativeCaptions: 'negative_captions',
        negativeComments: 'negative_comments',
        negativeInteractions: 'negative_interactions',
        negativeMedia: 'negative_media',
        positiveCaptions: 'positive_captions',
        positiveComments: 'positive_comments',
        positiveInteractions: 'positive_interactions',
        positiveMedia: 'positive_media',
        professional: 'ig_professional',
        profileLink: 'ig_profile_link',
        username: 'ig_username',
        website: 'ig_website',
    },
} as const;

export const IgUser2Enum = {
    prefix: 'contact2',
    fields: {
        username: 'ig_username',
        image: 'ig_image',
        level: 'ig_level',
    },
} as const;

export const IgMetadataLabelEnum = {
    prefix: 'metadata_label',
    fields: {
        igAccount: 'ig_account',
        mediaId: 'media_id',
        label: 'label',
        labels: 'labels',
        count: 'count',
    },
} as const;

export const IgMetadataEmotionEnum = {
    prefix: 'metadata_emotion',
    fields: {
        igAccount: 'ig_account',
        mediaId: 'media_id',
        emotion: 'emotion',
        emotions: 'emotions',
        count: 'count',
    },
} as const;

export const IgMetadataGenderEnum = {
    prefix: 'metadata_gender',
    fields: {
        igAccount: 'ig_account',
        mediaId: 'media_id',
        gender: 'gender',
        genders: 'genders',
        count: 'count',
    },
} as const;

export const IgMetadataAgeEnum = {
    prefix: 'metadata_age',
    fields: {
        igAccount: 'ig_account',
        mediaId: 'media_id',
        age: 'age',
        ages: 'ages',
        count: 'count',
    },
} as const;

export const IgMetadataFaceDetailEnum = {
    prefix: 'metadata_face_detail',
    fields: {
        igAccount: 'ig_account',
        mediaId: 'media_id',
        faceDetail: 'face_detail',
        faceDetails: 'face_details',
        count: 'count',
    },
} as const;

export const IgMetadataColorEnum = {
    prefix: 'metadata_color',
    fields: {
        igAccount: 'ig_account',
        mediaId: 'media_id',
        color: 'color',
        colors: 'colors',
        score: 'score',
    },
} as const;

export const IgMetadataHashtagEnum = {
    prefix: 'metadata_hashtag',
    fields: {
        igAccount: 'ig_account',
        mediaId: 'media_id',
        hashtag: 'hashtag',
        hashtags: 'hashtags',
    },
} as const;

export const ProductIgMediaEnum = {
    prefix: 'product_ig_media',
    fields: {
        ecommerceId: 'ecommerce_id',
        igAccount: 'ig_account',
        mediaId: 'media_id',
        productId: 'product_id',
        similarity: 'similarity',
        similarMediaImage: 'similar_media_image',
    },
} as const;

export const IgAudienceCountryEnum = {
    prefix: 'ig_audience_country',
    fields: {
        country: 'country',
        igAccount: 'ig_account',
        reach: 'reach',
        engagement: 'engagement',
        timeframe: 'timeframe',
        type: 'type',
        users: 'users',
        usersPercentage: 'users_percentage',
    },
} as const;

export const IgAudienceCityEnum = {
    prefix: 'ig_audience_city',
    fields: {
        city: 'city',
        engagement: 'engagement',
        igAccount: 'ig_account',
        reach: 'reach',
        timeframe: 'timeframe',
        type: 'type',
        users: 'users',
        usersPercentage: 'users_percentage',
    },
} as const;

export const IgAudienceGenderAgeEnum = {
    prefix: 'ig_audience_gender_age',
    fields: {
        ageRange: 'age_range',
        engagement: 'engagement',
        gender: 'gender',
        igAccount: 'ig_account',
        reach: 'reach',
        timeframe: 'timeframe',
        type: 'type',
        users: 'users',
        usersPercentage: 'users_percentage',
    },
} as const;

export const IgAudienceHourEnum = {
    prefix: 'ig_audience_hour',
    fields: {
        date: 'date',
        followers: 'followers',
        hour: 'hour',
        igAccount: 'ig_account',
        month: 'month',
        week: 'week',
        weekday: 'weekday',
    },
} as const;
